import { useAudioTrack } from '@daily-co/daily-react';
import { Badge, Indicator, Text } from '@mantine/core';
import { IconMicrophoneOff } from '@tabler/icons-react';
import { useEffect, useState } from 'react';
import { primaryColor } from '../../../../constants/theme';

interface TimerTextProps {
  endtime: Date;
  name: string;
  sessionId: string;
}

export const CallStatusBadge = ({
  endtime,
  name,
  sessionId,
}: TimerTextProps) => {
  const [timeRemaining, setTimeRemaining] = useState<string>();
  const { isOff: isAudioMuted, track: audioTrack } = useAudioTrack(sessionId);

  useEffect(() => {
    const interval = setInterval(() => {
      const remaining = getTimeRemaining();
      const minutes = Math.floor(remaining / 60);
      const seconds = remaining % 60;
      const formatted = `${minutes
        .toString()
        .padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
      setTimeRemaining(formatted);
    }, 1000);
    return () => clearInterval(interval);
  }, [endtime]);

  function getTimeRemaining() {
    const now = new Date();
    const utcEndTime = new Date(
      endtime.getTime() + endtime.getTimezoneOffset() * 60000
    );
    const diff = utcEndTime.getTime() - now.getTime();
    return Math.max(0, Math.floor(diff / 1000));
  }

  return (
    <div
      style={{
        position: 'absolute',
        top: '10px',
        right: '10px',
        zIndex: 10,
      }}
    >
      <Badge
        leftSection={isAudioMuted ? <IconMicrophoneOff size={15} /> : null}
        color={primaryColor}
      >
        {name} | {timeRemaining}
      </Badge>
    </div>
  );
};
